import React from 'react';
import { injectIntl } from 'react-intl';
import LocalizedLink from '../../components/LocalizedLink';
import PricingLanding from '../Home/scenes/PricingLanding';

const texts = {
  fr: {
    title: 'Tarifs',
    intro: 'Ces formules s’adressent aux bureaux d’études et aux indépendants qui utilisent l’App Store TriDyme en libre-service. Pour un déploiement sur un parc d’ouvrages ou un projet grand compte, l’offre est établie sur proposition.',
    cta: 'Parler à un expert',
  },
  en: {
    title: 'Pricing',
    intro: 'These plans are for engineering firms and independent engineers using the TriDyme App Store on a self-service basis. For a deployment across an asset portfolio or an enterprise project, we provide a tailored proposal.',
    cta: 'Talk to an expert',
  },
};

const Pricing = ({ intl: { locale } }) => {
  const t = texts[locale] || texts.fr;
  return (
    <div className="landing-page pricing-page">
      <section className="page-intro">
        <h1>{t.title}</h1>
        <p>{t.intro}</p>
        <LocalizedLink to="/contact/?subject=enterprise" className="btn-landing btn-outline">
          {t.cta}
        </LocalizedLink>
      </section>
      <PricingLanding />
    </div>
  );
};

export default injectIntl(Pricing);
